import React from 'react';
import PropTypes from 'prop-types';
import { fields } from './fields';
import fieldSelection from '..';

const Schedule = ({
  className,
  formProps,
  activeTab,
  displayView,
  formItem,
  editMode,
  disabled,
}) => {
  const scheduleFields = fields({
    values: formProps.values,
    activeTab,
    displayView,
    formItem,
    editMode,
    initialValues: formProps.initialValues,
    disabled,
  });
  return (
    <div className={className}>
      {scheduleFields.map(item =>
        fieldSelection({ item, key: item.field, props: formProps }),
      )}
    </div>
  );
};

Schedule.propTypes = {
  className: PropTypes.string,
  formProps: PropTypes.object,
  activeTab: PropTypes.string,
  displayView: PropTypes.array,
  formItem: PropTypes.object,
  editMode: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default Schedule;
